export { default } from './YhUploadTable';
export * from './interface'; 